import LoadPanel from 'devextreme-react/load-panel';
import 'devextreme/dist/css/dx.common.css';
import pMinDelay from 'p-min-delay';
import React, { useEffect } from 'react';
import { QueryClient } from "react-query";
import { Provider, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import { authApi } from './api/auth';
import { Loadable } from './components/loadable';
import LoaderPage, { LoaderApp } from './components/loader-page';
import Content from './Content';
import { AuthProvider } from './contexts/auth';
import { NavigationProvider } from './contexts/navigation';
import StoreProvider from "./contexts/store";
import { TranslateProvider } from './contexts/translate';
import './dx-styles.scss';
import { authActionTypes } from './state/reducers/authReducer';
import { store } from "./state/store";
import './style.css';
import './themes/generated/theme.additional.css';
import './themes/generated/theme.base.css';
import UnAuthorizedContent from './UnAuthorizedContent';
import { useScreenSizeClass } from './utils/media-query';
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}
const pMinDelayTime = 250;
export const ContentPage = Loadable(() => pMinDelay(import('./Content'), pMinDelayTime), { fallback: <LoaderPage /> });
export const NotAuthenticatedContentPage = Loadable(() => pMinDelay(import('./NotAuthenticatedContent'), pMinDelayTime), { fallback: <LoaderPage /> });

function App() {
    const dispatch = useDispatch();
    const { isLoading, user, isError, isGettingProfile } = useSelector(x => x.auth)

    useEffect(() => {
        handleGetUserInfo();
    }, [])
    const handleGetUserInfo = async () => {
        dispatch({ type: authActionTypes.GET_INFO.START })
        const res = await authApi.getUser();
        if (res) {
            if (res.is_success) {
                dispatch({ type: authActionTypes.GET_INFO.SUCESS, payload: res.data })
            } else {
                dispatch({ type: authActionTypes.GET_INFO.ERROR, payload: res.message ? res.message : "" })
            }
        } else {
            dispatch({ type: authActionTypes.GET_INFO.ERROR, payload: "" })
        }
    }
    if (isGettingProfile) {
        return <LoaderApp />
    }
    // return (
    //     <>
        
    //         {isLoading && <LoadPanel visible={true} />}
    //         {user && <ContentPage />}
    //         {!user && !isGettingProfile && <UnAuthorizedContent />}
    //         {/* {!isLoading && user && user.id > 0 && <Content />} */}
    //     </>
    // );
    if (user) {
        if (!user && !isGettingProfile) {
            return <UnAuthorizedContent/>
        } else {
            return <ContentPage />;
        }

    }
    else {
        if (!user && !isGettingProfile) {
            return <UnAuthorizedContent />
        } else {
            return <LoadPanel visible={true} />;
        }
    }

}


export default function () {
    const screenSizeClass = useScreenSizeClass();
    const queryClient = new QueryClient();

    return (
        <Router>
            <Provider store={store}>
                <AuthProvider>
                    <StoreProvider>
                        <NavigationProvider>
                            <TranslateProvider>
                                {/* <QueryClientProvider client={queryClient}> */}
                                <div className={`app ${screenSizeClass}`}>
                                    <App />
                                </div>
                                {/* </QueryClientProvider> */}
                            </TranslateProvider>
                        </NavigationProvider>
                    </StoreProvider>
                </AuthProvider>
            </Provider>

        </Router>
    );
}
